export default "__VITE_ASSET__CnCexWnb__"